const logos = [
  "https://images.seeklogo.com/logo-png/48/2/people-magazine-logo-png_seeklogo-482902.png",
  "https://logos-world.net/wp-content/uploads/2020/11/The-New-York-Times-Logo-700x394.png",
  "https://logos-world.net/wp-content/uploads/2021/11/Vogue-Logo-700x394.png",
  "https://www.logo.wine/a/logo/Entertainment_Weekly/Entertainment_Weekly-Logo.wine.svg",
  "https://www.logo.wine/a/logo/Deadline_Hollywood/Deadline_Hollywood-Logo.wine.svg",
  "https://www.pngfind.com/pngs/m/537-5378381_us-weekly-logo-us-weekly-hd-png-download.png",
  "https://www.logo.wine/a/logo/BBC_World_Service/BBC_World_Service-Logo.wine.svg",
  "https://www.logo.wine/a/logo/WarnerMedia/WarnerMedia-Logo.wine.svg",
  "https://www.logo.wine/a/logo/Last_Week_Tonight_with_John_Oliver/Last_Week_Tonight_with_John_Oliver-Logo.wine.svg",
  "https://www.logo.wine/a/logo/The_New_Yorker/The_New_Yorker-Logo.wine.svg",
  "https://www.logo.wine/a/logo/USA_Today/USA_Today-Logo.wine.svg",
  "https://www.logo.wine/a/logo/Ticketmaster/Ticketmaster-Logo.wine.svg",
  "https://www.logo.wine/a/logo/South_China_Morning_Post/South_China_Morning_Post-Logo.wine.svg",
  "https://www.logo.wine/a/logo/BET/BET-Logo.wine.svg",
  "https://www.logo.wine/a/logo/Entertainment_One/Entertainment_One-Logo.wine.svg",
];

export default logos;
